"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _Countdown = require("./Countdown.style");

var _countdownCalculator = require("./countdownCalculator");

var _CountdownBody = _interopRequireDefault(require("./CountdownBody"));

var _types = _interopRequireDefault(require("./types"));

var Countdown = function Countdown(_ref) {
  var date = _ref.date,
      variant = _ref.variant,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, ["date", "variant", "id"]);

  var _ref2 = (0, _react.useState)((0, _countdownCalculator.calculateTimeLeft)(date)),
      _ref3 = _slicedToArray(_ref2, 2),
      timeLeft = _ref3[0],
      setTimeLeft = _ref3[1];

  (0, _react.useEffect)(function () {
    var timer = setTimeout(function () {
      setTimeLeft((0, _countdownCalculator.calculateTimeLeft)(date));
    }, 1000); // Clear timeout when the component is unmounted

    return function () {
      return clearTimeout(timer);
    };
  });
  var timerComponents = [];
  Object.keys(timeLeft).forEach(function (interval) {
    if (timeLeft[interval] && timeLeft[interval] >= 0) {
      timerComponents.push( /*#__PURE__*/_react.default.createElement(_Countdown.TimerWrapper, {
        key: "timer-".concat(interval),
        time: timeLeft[interval]
      }, /*#__PURE__*/_react.default.createElement(_Countdown.TimeLeft, {
        variantType: variant
      }, timeLeft[interval]), /*#__PURE__*/_react.default.createElement(_Countdown.Interval, null, interval)));
    }
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, variant === _types.default.light ? /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: "12",
    id: id
  }, /*#__PURE__*/_react.default.createElement(_CountdownBody.default, Object.assign({
    variant: variant,
    timerComponents: timerComponents
  }, rest))) : /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_CountdownBody.default, Object.assign({
    variant: variant,
    timerComponents: timerComponents
  }, rest))));
};

Countdown.propTypes = {
  id: _propTypes.default.string,
  cta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }).isRequired,
  date: _propTypes.default.number.isRequired,
  variant: _propTypes.default.oneOf([_types.default.fixed, _types.default.regular, _types.default.light]),
  title: _propTypes.default.string,
  expiredMsg: _propTypes.default.string
};
Countdown.defaultProps = {
  id: '',
  variant: _types.default.regular,
  title: '',
  expiredMsg: 'Time is up!!'
};
var _default = Countdown;
exports.default = _default;